import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { AlertTriangle } from "lucide-react";

export function ConfirmDialog({ open, onOpenChange, title, description, confirmLabel = "Confirm", cancelLabel = "Cancel", variant = "destructive", onConfirm, loading = false }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-card border-border sm:max-w-md" data-testid="confirm-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 font-heading">
            <AlertTriangle className={`w-5 h-5 ${variant === "destructive" ? "text-red-400" : "text-amber-400"}`} />
            {title}
          </DialogTitle>
          <DialogDescription className="text-muted-foreground text-sm">{description}</DialogDescription>
        </DialogHeader>
        <DialogFooter className="gap-2 sm:gap-0">
          <Button variant="ghost" onClick={() => onOpenChange(false)} disabled={loading} data-testid="confirm-cancel-btn">
            {cancelLabel}
          </Button>
          <Button
            variant={variant}
            onClick={() => { onConfirm(); onOpenChange(false); }}
            disabled={loading}
            data-testid="confirm-action-btn"
          >
            {loading ? "Processing..." : confirmLabel}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
